export default __webpack_public_path__ + "static/media/home-creative-agency-img-05.04e66b78.jpg";